import { render, staticRenderFns } from "./fragment-container.vue?vue&type=template&id=58b36e6e&scoped=true&"
import script from "./fragment-container.vue?vue&type=script&lang=js&"
export * from "./fragment-container.vue?vue&type=script&lang=js&"
import style0 from "./fragment-container.vue?vue&type=style&index=0&id=58b36e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b36e6e",
  null
  
)

export default component.exports